import { combineReducers } from '@ynap/reducer-utils';

import { default as contentReducer } from './contentReducer';
import { default as responseReducer } from './responseReducer';

export default combineReducers({
    designers: responseReducer,
    content: contentReducer,
});
